import React, { useEffect, useState } from "react";
import styles from "./Card.module.css";
import { useNavigate } from "react-router-dom";

const CardSummary = ({
  subTotal,
  taxes,
  currency,
  grandTotal,
  discountAmount,
  comment,
  fromCheckOut = false,
  totalItems,
  translations,
  variant = "default",
  checkoutDisabled = false,
  onUpdateCart,
  onResetCart,
  updating = false,
}) => {
  const [commentOrder, setCommentOrder] = useState("");
  const navigate = useNavigate();
  const handleChange = (event) => {
    setCommentOrder(event.target.value);
  };

  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleProceedToCheckout = () => {
    if (!isChecked || checkoutDisabled) return;

    navigate("/shoppingCart/checkout", {
      state: {
        data: {
          subTotal,
          grandTotal,
          taxes,
          currency,
          discountAmount,
          commentOrder,
          totalItems,
        },
      },
    });
  };

  useEffect(() => {
    setCommentOrder(comment || "");
  }, [comment]);

  const formatPrice = (value) => {
    const numericValue = Number(value) || 0;
    return Number.isInteger(numericValue)
      ? numericValue
      : numericValue.toFixed(2);
  };

  return (
    <div
      className={`${styles.cardSummary} ${
        variant === "shoppingCart" ? styles.shoppingCartSummary : ""
      }`}
    >
      {fromCheckOut ? (
        <div className={styles.billingTitle}>
          {translations?.result?.OrderSummary}
        </div>
      ) : (
        <div className={styles.billingTitle}>
          {translations?.result?.BillingSummary}
        </div>
      )}

      <div>
        <div className={styles.cardSummaryDetails}>
          <span>{translations?.result?.Subtotal}</span>
          <span className={styles.summaryPrice}>
            + {formatPrice(subTotal)} {currency}
          </span>
        </div>

        <div className={styles.cardSummaryDetails}>
          <span>{translations?.result?.Discount}</span>
          <span className={styles.summaryPrice}>
            - {formatPrice(discountAmount)} {currency}
          </span>
        </div>

        <div className={styles.cardSummaryDetails}>
          <span>{translations?.result?.Tax}</span>
          <span className={styles.summaryPrice}>
            + {formatPrice(taxes)} {currency}
          </span>
        </div>
      </div>

      <div className={styles.divider}></div>
      <div className={`${styles.cardSummaryDetails} ${styles.total}`}>
        <span className={styles.totalLabel}>
          {translations?.result?.SubtotalTotal}
        </span>
        <span className={`${styles.summaryPrice} ${styles.totalAmount}`}>
          {formatPrice(grandTotal)} {currency}
        </span>
      </div>

      {(fromCheckOut === false || (fromCheckOut && commentOrder)) && (
        <div>
          <div className={styles.orderCommentLabel}>
            {translations?.result?.OrderComment}
          </div>
          {fromCheckOut ? (
            <input
              type="text"
              value={commentOrder}
              onChange={handleChange}
              className={styles.orderComment}
              disabled={Boolean(commentOrder)}
            />
          ) : (
            <textarea
              rows="3"
              value={commentOrder}
              onChange={handleChange}
              className={styles.orderComment}
              placeholder={translations?.result?.TypeHere || "Type here..."}
            />
          )}
        </div>
      )}

      {fromCheckOut === false && checkoutDisabled && (
        <div className={styles.cartEditActions}>
          <button
            type="button"
            className={styles.resetCartButton}
            onClick={onResetCart}
            disabled={updating}
          >
            {translations?.result?.Reset || "Reset"}
          </button>
          <button
            type="button"
            className={styles.updateCartButton}
            onClick={onUpdateCart}
            disabled={updating}
          >
            {updating
              ? translations?.result?.Updating || "Updating..."
              : translations?.result?.Update || "Update"}
          </button>
        </div>
      )}

      {fromCheckOut === false && (
        <div>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              className="custom-checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              required
            />
            {translations?.result?.PleaseCheckAcknowledge}
          </label>
          {checkoutDisabled && (
            <div className={styles.pendingChangesMessage}>
              {translations?.result?.UpdateOrResetCart ||
                "Update or reset your cart changes to continue."}
            </div>
          )}
          <div>
            <button
              type="button"
              className={styles.checkoutButton}
              disabled={!isChecked || checkoutDisabled}
              onClick={handleProceedToCheckout}
            >
              {translations?.result?.ProceedToCheckout}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardSummary;
